
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/google-account-deletion",
      function () {
        return require("private-next-pages/[lang]/legal/google-account-deletion/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/google-account-deletion"])
      });
    }
  